import React, { useRef, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import { doChangeBlogIndexInView } from "../ducks";

const select = ({ interactiveMap }) => ({
  blogIndexInView: interactiveMap.blogIndexInView - 1
});

const actions = {
  changeBlogIndexInView: doChangeBlogIndexInView
};

function Blog({ countryName, events, blogIndexInView, changeBlogIndexInView }) {
  const ref = useRef();
  useEffect(() => {
    changeBlogIndexOnScroll(ref, changeBlogIndexInView);
  }, []);

  return (
    <Container ref={ref} id="blogs">
      <Title>{countryName}</Title>
      {events.map((event, i) => (
        <EventContainer inView={i === blogIndexInView}>
          <EventLocation inView={i === blogIndexInView}>
            {event.location.name}
          </EventLocation>
          {event.paragraphs.map(p => (
            <Paragraph>{p}</Paragraph>
          ))}
        </EventContainer>
      ))}
      <Spacer />
    </Container>
  );
}

export default connect(
  select,
  actions
)(Blog);

const Container = styled.div`
  height: calc(100vh - 7em);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 1em;
  @media (max-width: 600px) {
    height: auto;
  }
`;
const Paragraph = styled.p`
  @media (max-width: 600px) {
    font-size: 18px;
  }
`;

const Title = styled.h1``;

const EventLocation = styled.h3`
  color: ${({ inView }) => (inView ? "turquoise" : "black")};
`;

const EventContainer = styled.div`
  box-sizing: border-box;
  border: 2px solid white;
  border-left: none;
  border-right: none;
  opacity: ${({ inView }) => (inView ? "1" : "0.2")};
  @media (min-width: 600px) {
    border-color: ${({ inView }) => (inView ? "turquoise" : "white")};
  }
  transition: 0.2s ease;
`;

const Spacer = styled.div`
  height: ${window.innerHeight / 3}px;
  background-color: white;
`;

function changeBlogIndexOnScroll(ref, changeIndexCallback) {
  let blogEntries = getBlogEntries(ref);
  let offsetPositions = getBlogEntryOffsetPositions(blogEntries);
  const elementBeingScrolled = isMobile() ? document : ref.current;

  elementBeingScrolled.addEventListener(
    "scroll",
    registerActiveIndex(offsetPositions, changeIndexCallback)
  );
}

const registerActiveIndex = (thresholds, changeIndexCallback) => e => {
  const scrollPosition = getScrollPositionFromEvent(e);
  const currentIndex = getCurrentBlogIndexInView(scrollPosition, thresholds);
  changeIndexCallback(currentIndex);
};

function getScrollPositionFromEvent(e) {
  return isMobile()
    ? document.scrollingElement.scrollTop
    : e.srcElement.scrollTop;
}

function getCurrentBlogIndexInView(scrollPosition, thresholds) {
  const numElementsScrolledPast = thresholds.filter(
    threshold => scrollPosition < threshold
  ).length;
  let currentIndex = thresholds.length - numElementsScrolledPast;
  if (currentIndex === 0) currentIndex = 1;
  return currentIndex;
}

function getBlogEntries(ref) {
  return Array.from(ref.current.children).slice(1);
}

function getBlogEntryOffsetPositions(blogEntries) {
  return blogEntries.map(item => determineOffset(item));
}
function determineOffset(item) {
  return item.offsetTop - window.innerHeight / 2;
}

function isMobile() {
  return window.innerWidth < 600;
}
